export const SYNC_SESSION_ROUTE = '/__/sync_user_session';
export const SHARE_USER_SESSION_EVENT = 'TADARIDA_sync_user_session';
